import { connect } from 'react-redux';
import _ from 'lodash';
import {
  updateFormData,
  getDataCredential,
  addCredentialAndProbe,
  updateCredentialAndProbe,
  setContextualSupport,
  unsetContextualSupport,
  loadFullVendor,
} from 'js/actions';
import { getAccessToken, getConnectionTypes } from '../../reducers/selectors';
import {
  ADD_CREDENTIAL_REQUEST,
  UPDATE_CREDENTIAL_REQUEST,
  PROBE_CREDENTIAL_REQUEST,
  GET_CREDENTIAL_REQUEST,
  GET_FULL_VENDOR_REQUEST,
} from 'js/constants/actionTypes';
import { FORM_TYPE_EDIT_CREDENTIAL } from 'js/constants/formTypes';
import UIUtils from 'js/lib/UIUtils';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import * as OLD_PATHS from 'js/constants/pathnames';
import CredentialForm from './CredentialForm';

const mapStateToProps = (state, ownProps) => {
  const {
    forms,
    entities: { credentials, vendors },
    vendors: vendorsState,
    paging,
    request,
  } = state;
  const credentialId = _.get(ownProps, 'credentialId', UIUtils.extractParamFromURL(ownProps.match));
  const credential = credentials && credentialId && credentials[credentialId];
  const form = forms[FORM_TYPE_EDIT_CREDENTIAL];
  const formData = form && form.data;
  const credentialData = (formData && formData.credentialData) || {};
  const addedCredentialId = formData && formData.addedCredentialId;
  const saveError = formData && formData.saveError;
  const vendorsLoaded = vendorsState.vendors.lastUpdated;
  const isLoading = !!(
    request[ADD_CREDENTIAL_REQUEST] ||
    request[UPDATE_CREDENTIAL_REQUEST] ||
    request[PROBE_CREDENTIAL_REQUEST] ||
    request[GET_CREDENTIAL_REQUEST]
  );

  return {
    credentialId,
    credential,
    credentialData,
    addedCredentialId,
    saveError,
    vendors,
    paging,
    connectionTypes: getConnectionTypes(state),
    vendorsLoaded,
    isLoading,
    loadingVendorInfo: !!request[GET_FULL_VENDOR_REQUEST],
    accessToken: getAccessToken(state),
    // Same value as `accessToken` above, named for what it is. The legacy OAuth services read
    // `accessToken`; new code reads this. Drop `accessToken` when those services go.
    nexlaSessionToken: getAccessToken(state),
  };
};

const CredentialFormContainer = connect(mapStateToProps, {
  loadFullVendor,
  updateFormData,
  getDataCredential,
  addCredentialAndProbe,
  updateCredentialAndProbe,
  setContextualSupport,
  unsetContextualSupport,
})(CredentialForm);

CredentialFormContainer.screenConfig = {
  screenName: 'CredentialFormContainer',
  domain: 'integrate',
  pageTitle: 'New Credential',
  path: [
    `${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_CREDENTIALS}/:id/edit`,
    `${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_CREDENTIALS}/new`,
  ],
};

export default CredentialFormContainer;
